module.exports = __webpack_public_path__ + "img/itx-file-type-odm.4c6206da.svg";